$(document).ready(function(){

	var $carousel = $('.carousel');

	$carousel.slick({
		prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Vorheriges</span></button>',
		nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Nächstes</span></button>',
		slidesToShow : 3,
		slidesToScroll: 3,
		arrows : true,
		dots: true,
		slide : '.media',
		adaptiveHeight: false,
		fade: false,
		speed: 500,
		autoplay : false,
		autoplaySpeed : 5000,
		responsive : [
			{ 
				breakpoint: 992,
				settings: { 
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows : true
				}
			},
			{ 
				breakpoint: 640,
				settings: { 
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : false
				}
			}
		]
	});
	
});